import { isRouteErrorResponse, Link, useRouteError } from 'react-router-dom'

/**
 * 라우터 `errorElement` (설계 §2-2(2)).
 *
 * 🚨 이게 없으면 렌더 예외가 **흰 화면**이 된다 — 사용자는 물론 운영자도 원인을 알 수 없다.
 * 여기서는 토큰·응답 본문 같은 민감 정보를 노출하지 않고 상태/메시지까지만 보여준다.
 */
export function RouteError() {
  const error = useRouteError()

  const detail = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : '알 수 없는 오류'

  return (
    <div className="flex min-h-full flex-col items-center justify-center gap-3 px-6 py-16 text-center">
      <p className="text-lg font-semibold text-ink-700">화면을 표시하지 못했습니다</p>
      <p className="text-sm text-slateish-600">
        일시적인 오류일 수 있습니다. 새로고침하거나 처음 화면으로 돌아가 주세요.
      </p>
      <p className="text-xs text-slateish-400">{detail}</p>
      <Link
        to="/"
        className="mt-2 rounded-lg border border-brand-500 px-4 py-2 text-sm font-medium text-brand-500"
      >
        처음 화면으로
      </Link>
    </div>
  )
}
